export default "__VITE_ASSET__q0Pzh9PU__"